/* Toasty Golf - Persist pinned collection route (2026-05-21)
Keeps ad-clicked and email-clicked products pinned first during the current tab session */
(() => {
  const COLLECTION_PATH = '/collections/all-products';
  const STORAGE_KEY = 'tg_pinned_collection_handle';

  const normalizePath = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.pathname.replace(/\/$/, '');
    } catch (error) {
      return '';
    }
  };

  const normalizeHandle = (value) => {
    if (!value) return '';

    try {
      return decodeURIComponent(value)
        .trim()
        .replace(/^\/+|\/+$/g, '')
        .split('?')[0]
        .split('#')[0];
    } catch (error) {
      return '';
    }
  };

  const getHandleFromProductUrl = (value) => {
    try {
      const decodedValue = decodeURIComponent(value);
      const productMatch = decodedValue.match(/\/products\/([^/?#&]+)/);
      return productMatch && productMatch[1] ? normalizeHandle(productMatch[1]) : '';
    } catch (error) {
      return '';
    }
  };

  const getHandleFromProductPath = (path) => {
    const productMatch = path.match(/^\/products\/([^/?#]+)$/);
    return productMatch && productMatch[1] ? normalizeHandle(productMatch[1]) : '';
  };

  const hasPinnedProductSignal = (url) => {
    const signalParams = [
      'first',
      'fbclid',
      'gclid',
      '_kx',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'campaign_id',
      'adset_id',
      'ad_id',
      'tg_pin'
    ];

    return signalParams.some((param) => url.searchParams.has(param));
  };

  const currentUrl = new URL(window.location.href);
  const currentPath = normalizePath(window.location.href);
  const pinnedMatch = currentPath.match(/^\/collections\/all-products\/([^/?#]+)$/);
  const firstParam = currentUrl.searchParams.get('first');

  try {
    if (pinnedMatch && pinnedMatch[1]) {
      sessionStorage.setItem(STORAGE_KEY, normalizeHandle(pinnedMatch[1]));
    } else if (firstParam) {
      const handleFromFirst = getHandleFromProductUrl(firstParam) || normalizeHandle(firstParam);

      if (handleFromFirst) {
        sessionStorage.setItem(STORAGE_KEY, handleFromFirst);
      }
    } else if (hasPinnedProductSignal(currentUrl)) {
      const currentProductHandle = getHandleFromProductPath(currentPath);

      if (currentProductHandle) {
        sessionStorage.setItem(STORAGE_KEY, currentProductHandle);
      }
    }
  } catch (error) {
    return;
  }

  let pinnedHandle = '';

  try {
    pinnedHandle = sessionStorage.getItem(STORAGE_KEY) || '';
  } catch (error) {
    return;
  }

  if (!pinnedHandle) return;

  const pinnedPath = `${COLLECTION_PATH}/${encodeURIComponent(pinnedHandle)}`;

  document.querySelectorAll('a[href]').forEach((link) => {
    const linkPath = normalizePath(link.href);

    if (linkPath === COLLECTION_PATH) {
      link.href = pinnedPath;
    }
  });
})();
